<template>
  <main>
    <h2 class="ttl"><img src="/img/ico_user2.png" alt="会員情報の登録" width="40" class="mb30"><br>{{$t('phoneRegistrationComplete')}}</h2>
    <p v-if="this.show" class="btn-normal-2 mt60"><a href="/">{{$t('topPage')}}</a></p>
  </main>
</template>

<script>
import firebase from 'firebase'
import i18n from '../../i18n'

export default {
  name: 'AccountValidatePhoneCompleted',
  data () {
    return {
      i18n:i18n,
      db: firebase.firestore(),
      user: firebase.auth().currentUser,
      show:true,
    }
  },
  methods:{
    notAvailable(){
      window.alert(this.$t('downloadNotAvailable'));
    }
  },
  async created(){
    this.$parent.isLogin=true;
  }
}
</script>
